module.exports = __webpack_public_path__ + "img/sh_qrcode.bdb3786a.jpg";